import { useCallback } from "react";
import { useSelector } from "react-redux";
import { type ParametricSelector, createSelectorCreator, defaultMemoize } from "reselect";

import { isDeepEqual } from "~/tools/is-deep-equal";

/**
 * creates a "selector creator" that uses lodash.isequal instead of ===
 * more info https://github.com/reduxjs/reselect#customize-equalitycheck-for-defaultmemoize
 */
export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isDeepEqual);

/**
 * Use in combination with a paremetric selector (selector that take an additional parameter, besides the state).
 */
export const useParametricSelector = <TState, TParam, TResult>(
	parametricSelector: ParametricSelector<TState, TParam, TResult>,
	param: TParam,
): TResult =>
	useSelector(useCallback((state: TState) => parametricSelector(state, param), [parametricSelector, param]));
